/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

// Owner invoices.
export const INVOICE_LESSOR_FIRST_INVOICE = 'lessor_first_invoice'
export const INVOICE_MANAGEMENT = 'management'
export const INVOICE_OWNER = 'owner'

// Tenant invoices.
export const INVOICE_RENT = 'rent'
export const INVOICE_TENANT = 'tenant'
export const INVOICE_TENANT_FIRST_INVOICE = 'tenant_first_invoice'

// Other invoices.
export const INVOICE_CREDIT = 'credit'
export const INVOICE_ESTIMATION = 'estimation'
export const INVOICE_PROFORMA = 'proforma'
export const INVOICE_SALE = 'sale'

const InvoiceTypes = [
  INVOICE_CREDIT,
  INVOICE_ESTIMATION,
  INVOICE_LESSOR_FIRST_INVOICE,
  INVOICE_MANAGEMENT,
  INVOICE_OWNER,
  INVOICE_PROFORMA,
  INVOICE_RENT,
  INVOICE_SALE,
  INVOICE_TENANT,
  INVOICE_TENANT_FIRST_INVOICE
]

export default InvoiceTypes
